import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

interface StreetMapViewProps {
    onClose: () => void;
    longitude: string;
    latitude: string;
}

export default function StreetMapView({ onClose, longitude, latitude }: StreetMapViewProps) {
    const lat = parseFloat(latitude);
    const lng = parseFloat(longitude);

    const isValidCoordinates = !isNaN(lat) && !isNaN(lng);

    return (
        <section className="modal-section reservation" onClick={onClose} style={{ zIndex: 1100 }}>
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                        {isValidCoordinates ? (
                            <MapContainer
                                center={[lat, lng]}
                                zoom={15}
                                scrollWheelZoom={true}
                                style={{ height: '400px', width: '100%', borderRadius: '12px' }}
                            >
                                <TileLayer
                                    attribution='&copy; OpenStreetMap contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />

                                <Marker position={[lat, lng]}>
                                    <Popup>
                                        Lokacija lokala
                                    </Popup>
                                </Marker>
                            </MapContainer>
                        ) : (
                            <p>Koordinate nisu ispravne.</p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}



delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});